var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ts-metric"},[_c('p',{staticClass:"value"},[_vm._t("default")],2),(_vm.title)?_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }